import { useNavigate } from "react-router-dom";
import { categories } from "@/mocks/anime";

export default function Hero() {
  const navigate = useNavigate();

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    const kw = String(fd.get("kw") || "").trim();
    navigate(kw ? `/list?q=${encodeURIComponent(kw)}` : "/list");
  };

  return (
    <section className="relative flex min-h-[560px] items-center overflow-hidden md:min-h-[640px]">
      <img
        src="https://readdy.ai/api/search-image?query=a%20cinematic%20anime%20collage%20of%20dramatic%20fantasy%20worlds%20with%20swordsman%2C%20mecha%2C%20sakura%20and%20neon%20city%20scenes%2C%20warm%20amber%20and%20deep%20orange%20color%20palette%2C%20dynamic%20lighting%20and%20floating%20embers%2C%20dark%20vignette%20edges%20for%20text%20contrast%2C%20epic%20atmospheric%20illustration%20with%20rich%20detail&width=1600&height=900&seq=hero-key-2026&orientation=landscape"
        alt="奶水动漫热门动画合集视觉"
        title="奶水动漫在线观看与下载资源"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/95 via-background-950/80 to-background-950/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-transparent to-background-950/60" />

      <div className="container-site relative z-10 py-24 md:py-32">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/40 bg-primary-500/10 px-3 py-1 text-xs font-medium text-primary-400">
          <i className="ri-flashlight-fill" /> 资源持续更新 · 高清全集免费看
        </span>
        <h1 className="mt-5 max-w-2xl font-heading text-4xl leading-tight text-foreground-50 md:text-6xl md:leading-tight">
          一网打尽<span className="text-primary-400">热门动画</span>
          <br />
          点开即追更
        </h1>
        <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-300 md:text-base">
          奶水动漫为你免费提供热门动画在线观看、全集收录与高清下载。覆盖热血、奇幻、科幻、恋爱等多类型，无需繁琐步骤，找番、看番、存番一站式搞定。
        </p>

        <form
          onSubmit={submit}
          className="mt-7 flex w-full max-w-xl flex-col gap-2 sm:flex-row sm:items-center sm:rounded-full sm:border sm:border-background-700 sm:bg-background-900/80 sm:p-1.5"
        >
          <div className="flex items-center gap-2 rounded-full bg-background-900/80 px-4 sm:flex-1 sm:bg-transparent sm:p-0">
            <i className="ri-search-line text-foreground-400" />
            <input
              name="kw"
              placeholder="搜索番名，例如：月下剑歌"
              className="w-full bg-transparent py-3 text-sm text-foreground-100 outline-none placeholder:text-foreground-500 sm:py-2"
            />
          </div>
          <button type="submit" className="btn-primary sm:rounded-full">
            立即搜索
          </button>
        </form>

        <div className="mt-6 flex flex-wrap gap-2">
          {categories.slice(0, 8).map((c) => (
            <button
              key={c.name}
              onClick={() => navigate(`/list?cat=${encodeURIComponent(c.name)}`)}
              className="cursor-pointer rounded-full border border-background-700/70 bg-background-900/50 px-3 py-1.5 text-xs font-medium text-foreground-300 transition-colors hover:border-primary-500 hover:text-primary-400"
            >
              {c.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}